
export default {
  props: {
    clientData: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    // this.clientData = this.clientData[0].children.map(item => {
    //   return item.children.fitler(it => {
    //     return it.subTitle
    //   })
    // })
    console.log('clientData---', this.clientData)
  },
  methods: {},
}
